module.exports = __webpack_public_path__ + "img/banner1.0ff54084.png";